import SectionThreeCanvas from './three/SectionThreeCanvas';
import HeroScene from './three/scenes/HeroScene';

export default function HeroThreeBackground() {
  return (
    <SectionThreeCanvas
      camera={{ position: [0, 0, 9], fov: 42 }}
      dpr={[1, 1.75]}
      className="z-[1]"
    >
      <HeroScene />
    </SectionThreeCanvas>
  );
}
